var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.url)?[_c('pdf-viewer-ui',{attrs:{"src":_vm.url}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }